/**
 * @author harish.r <harish.r@314ecorp.com>
 * @description React Hook creating verification session
 */

import { useMutation, UseMutationResult } from '@tanstack/react-query';
import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';

/**
 * Mutate Creating Verification Session
 *
 */
const useCreateVerificationSession = (): UseMutationResult<string, IAxiosError, { providerId: string }, unknown> => {
	return useMutation({
		mutationFn: async ({ providerId }) => {
			const { data } = await api.EKYCServiceApi.createIdentificationSession({ providerId });
			return data;
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useCreateVerificationSession;
